export const SUPPORT_CENTER_URL = 'https://support.therecordbase.com/support';
export const SUPPORT_EMAIL = 'support@therecordbase.com';
export const PRIORITY_SUPPORT_CHAT_URL = 'https://chat.therecordbase.com';
export const FAST_SUPPORT_SLACK_URL = 'https://join.slack.com/t/therecordbasesupport/shared_invite/zt-3zjaejdsh-7lgxC8Wo1nb_dNovnylJUw';
export const TRB_DESK_AI_URL = 'https://chatgpt.com/g/g-6a4fdab8d4708191832c1065f0b90609-customer-support-agent';

export function buildSupportMailto() {
  return `mailto:${SUPPORT_EMAIL}`;
}
